<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜尋名稱" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<el-button class="mr-2" v-auth="'add'+auth_val" @click="openModel(false)" type="primary" size="mini">新增地區</el-button>

					<el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button>
				</template>
				
				<!-- 高級搜尋 -->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="地區名稱" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜尋地區名稱"></el-input>
						</el-form-item>
						<el-form-item label="創建時間"  size="small"  class="mb-0">
							 <el-date-picker
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      range-separator="至"
							      start-placeholder="開始日期"
							      end-placeholder="結束日期"
							      :picker-options="pickerOptions">
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>
				
					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column type="selection" width="45" align="center"></el-table-column>
				<el-table-column align="center" prop="serial" label="地區編號">
				</el-table-column>
				<el-table-column align="center" prop="name" label="地區名稱">
				</el-table-column>
				<el-table-column align="center"  width="180" prop="create_time" label="創建時間">
				</el-table-column>
				<el-table-column prop="id" align="center" width="140" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="primary" v-auth="'edit'+auth_val" @click="openModel(scope)">操作</el-button>
							<el-button @click="deleteItem(scope.row)" v-auth="'del'+auth_val" size="mini" plain type="danger">刪除</el-button>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>



		<el-dialog :close-on-click-modal="false"  :title="editIndex > -1 ? '修改地区' : '新增地區'" :visible.sync="createModel" top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item label="地區編號" prop="serial">
					<el-input v-model="form.serial" placeholder="地區編號" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item label="地區名稱" prop="name">
					<el-input v-model="form.name" placeholder="地區名稱" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">確 定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				//搜尋數据
				from: {
					name: '',
					username:'',
					status:-1,
					rule_id:'',
					time:[],
				},
				auth_val: 'Address',
				preUrl: "data/addressList", //列表地址
				addUrl: "data/addAddress", //添加/修改地址
				delAllUrl: "data/delAddressAll", //批量删除地址
				delUrl: "data/delAddress", //删除單条地址

				tableData: [],
				form: {
					id:0,
					name: "",
					serial: "",
					username: '',
					password: '',
					password2: '',
					headUrl: '',
					icon:'',
					status: 1,
					headId: 0,
					phone:'',
					email:'',
					local:'',
				},
				rules: {
					name: [{
							required: true,
							message: "地區名稱不能為空",
							trigger: 'blur',
						},

					],
					serial: [{
							required: true,
							message: "地區編號不能為空",
							trigger: 'blur',
						},

					]

				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			//this.commonList('shopList');
		},
		methods: {
			//提交
			submit() {
				
				this.$refs.form.validate(res => {
					
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						id:0,
						name: "",
						serial: "",
						username: '',
						password: '',
						password2: '',
						headUrl: '',
						icon:'',
						headId: 0,
						status: 1,
						phone:'',
						email:'',
						local:'',
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.row.id,
						name: e.row.name,
						serial: e.row.serial,
						username: e.row.username,
						password: '',
						password2: '',
						headUrl: e.row.head,
						icon:e.row.head,
						headId: 0,
						phone:e.row.phone,
						email:e.row.email,
						local:e.row.local,
						status: e.row.status,
					}
				
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.rule_list = list

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				console.log(file.type)
				if (!isJPG) {
				  this.$message.error('文件格式錯誤!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳圖片大小不能超過 2MB!');
				}
				return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					serial: '',
					username:'',
					status:-1,
					rule_id:'',
					time:[],
					end_time:''
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
